import React, {useEffect, useState} from 'react';
import {Template} from "../../../../../components/template/template.jsx";
import {Card} from "../../../../../components/card/card.jsx";
import InputForm from "../../../../../components/input/input-form.jsx";
import Button from "../../../../../components/button/button.jsx";
import {useParams} from "react-router";
import projectUtils from "../../../../../utils/project-utils.js";
import {navigateHook} from "../../../../../hooks/use-navigate.js";
import {useQuery} from "@tanstack/react-query";
import {FaPlus} from "react-icons/fa";
import SelectComponent from "../../../../../components/select/select-component.jsx";
import useFetchData from "../../hooks/use-fetch-options.js";
import materialAlertService from "../../../../../services/web/material-alert-service.js";

const initialData = {
    storage_id: "",
    material_id: "",
    quantity: ""
}

const MaterialAlertsForm = () => {
    const navigate = navigateHook();
    const {id} = useParams()
    const [isLoading, setIsLoading] = useState(false)
    const [data, setData] = useState(initialData)

    const {storageOptions, materialOptions} = useFetchData({fetchStorage: true, fetchMaterials: true});

    const { data: alert, refetch, status } = useQuery({
        queryKey: ['material-alert'],
        queryFn: async () => await materialAlertService.getById(id),
        enabled: !!id
    });

    useEffect(() => {
        if (status === "success") {
            const alertNormalized = projectUtils.normalizeData(alert)
            setData(alertNormalized)
        }
    }, [alert, status]);

    const saveAdd = () => save(true)

    const save = (saveAdd) => {
        setIsLoading(true);

        const formData = new FormData()
        Object.entries(data).forEach(([key, value]) => {
            formData.append(key, value);
        });

        materialAlertService.save(formData, id)
            .then(({data}) => {
                projectUtils.success(!id || saveAdd);

                if (saveAdd) {
                    setData(initialData)
                    navigate("/materials/alerts/form");
                    return;
                }

                if (id) {
                    refetch()
                    return;
                }

                const urlDev = `/materials/alerts/form/${data.id}`;
                navigate(urlDev);

            })
            .catch((error) => {
                console.error(error);
                let message = 'Não foi possível salvar.';
                if (error.response.status !== 500) {
                    message = error.response.data.message;
                }

                projectUtils.swalErrorMessage('', message, 'Ok');
            })
            .finally(() => setIsLoading(false))
    }

    const remove = async () => {
        const material = materialOptions.find(m => m.value === data.material_id)

        projectUtils.swalMessage(
            'warning',
            'Excluir',
            `Excluir o alerta do material "${material?.label || ""}"?`,
            'Sim',
            true,
            'Não',
            ({isConfirmed}) => {
                if (!isConfirmed) return

                materialAlertService.delete(id)
                    .then(() => {
                        projectUtils.success(true, "Excluído com sucesso")
                        navigate("/materials/alerts")
                    })
                    .catch(error => {
                        console.error(error);
                        let message = 'Não foi possível excluir.';
                        if (error.response.status !== 500) {
                            message = error.response.data.message;
                        }

                        projectUtils.swalErrorMessage('', message, 'Ok');
                    });
            }
        );
    }

    const openForm = () => {
        setData(initialData)
        const urlDev = `/materials/alerts/form`;
        navigate(urlDev)
    }

    return (<Template isLoading={isLoading}>
        <Template.Header>
            <Template.Title>
                Alerta
            </Template.Title>
            {
                id &&
                <Button target={"primary-outline"} onClick={openForm}>
                    <FaPlus/><span className="font-bold">Adicionar alerta</span>
                </Button>
            }
        </Template.Header>
        <Template.Body>
            <Card>
                <Card.Body>
                    <div className="grid grid-cols-12 gap-4">
                        <div className="col-span-5">
                            <SelectComponent
                                id="groups"
                                value={data.storage_id}
                                options={storageOptions || []}
                                label={"Depósito *"}
                                onChange={(selected) => setData(prevState => ({...prevState, storage_id: selected?.value || ""}))}
                            />
                        </div>
                        <div className="col-span-5">
                            <SelectComponent
                                id="groups"
                                value={data.material_id}
                                options={materialOptions || []}
                                label={"Material *"}
                                onChange={(selected) => setData(prevState => ({...prevState, material_id: selected?.value || ""}))}
                            />
                        </div>
                        <div className="col-span-2">
                            <InputForm
                                id="quantity"
                                name="quantity"
                                value={data.quantity}
                                onChange={({target: {value}}) => setData(prevState => ({...prevState, quantity: value}))}
                                label="Quantidade *"
                            />
                        </div>
                    </div>
                </Card.Body>
            </Card>

            <Card className={"mt-2"}>
                <Card.Body>
                    <div className="flex justify-end gap-2 w-full">
                        {!id &&
                            <Button target={"primary-outline"} onClick={saveAdd} actionFeedbackType='save'>Salvar e adicionar novo</Button>}
                        {id && <Button target={"danger"} onClick={remove} actionFeedbackType='delete'>Excluir</Button>}
                        <Button onClick={() => save(false)} actionFeedbackType='save'>Salvar</Button>
                    </div>
                </Card.Body>
            </Card>
        </Template.Body>
    </Template>);
};

export default MaterialAlertsForm;